import { z } from 'zod';

export const loginSchema = z.object({
   email: z.string().trim().min(1, 'Email is required').email('Invalid email'),
   password: z
      .string()
      .trim()
      .min(12, 'Password must be at least 12 characters')
      .regex(
         /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_\-+=\[\]{};':"\\|,.<>/?]).*$/,
         'Password must include at least one uppercase letter, one number, and one special character',
      ),
});

export type TLoginForm = z.infer<typeof loginSchema>;
